export const SocketConstants = Object.freeze({
    // SOCKET_CHAT_URL: 'https://test.akashkumarshukla.in',
    SOCKET_CHAT_URL: 'wss://websocket.test.viliyo.com',
});

export const seatingStyleTypes = {
    CLUSTER: "Cluster",
    USHAPED: "U-Shaped",
    CLASSROOM: "Classroom",
}

export const screenTypes = Object.freeze({
    JOIN: "join",
    STREAMING: "streaming",
    WAITINGROLEPLAY: "WaitingRoleplay",
    ROLEPLAY: "roleplay",
    CASESTUDY: 'casestudy',
    CUSTOMACTIVITY: 'customactivity',
    GROUPDISCUSSION: 'groupDiscussion',
    POLL: 'poll',
    HANDLE_AUDIO_VIDEO_DOC:'AudioVideoDocsActivity',
})

export const socketMessageType = Object.freeze({
    SHOW_EMOJIES: "show_emojies",
    SESSION_MODE: "session_mode",
    SHOW_BADGES: 'show_badges',
    // role play
    ROLE_PLAY: "role_play",
    MANUAL_ROLE_PLAY: 'manual_role_play',
    // end role play
    CASE_STUDY: 'case_study',
    GROUP_DISCUSSION: 'group_discussion',
    SPLIT_ROOM: "split_room",
    TRAINER_CHANGED_SEATING_STYLE: 'trainer_changed_seating_style',
    RECORDING: 'recording',
    SEGMENT_LAUNCHED: 'segment_launched',
    SHARE_SCREEN: 'screen_share',
    broadcast_poll: 'broadcast_poll',
    // Share whiteboard
    SHARE_WHITEBOARD: 'share_white_board',
    UNSHARE_WHITEBOARD: 'un_share_white_board',
    LIVE_SESSION:'live_session',
    SESSION_META_INFO:'session_meta_info',
})

export const socketMessageSubType = Object.freeze({
    MANUAL_CHANGE: 'manual_change',
    START_RECORDING: 'start_recording',
    STOP_RECORDING: 'stop_recording',
    LOG_SEGMENT_LAUNCH: 'log_segment_launch',
    SPOTLIGHT_TABLE_SET: 'spotlight_table_set',
    SPOTLIGHT_TABLE_UNSET: 'spotlight_table_unset',
    REQUEST_FOR_SHARE_SCREEN: 'request_for_share',
    RESPONSE_TO_SCREEN_SHARE: 'response_to_screen_share',
    TRAINER_ACTION: 'trainer_action',
    SHARE_WHITEBOARD_TRAINEE: 'share_white_board_trainee',
    UNSHARE_WHITEBOARD_TRAINEE:'un_share_white_board_trainee',
    DISABLE_SHARED_WHITEBOARD_TRAINEE: 'share_disabled_white_board_trainee',
    ALLOW_LAUNCH_WHITEBOARD_IN_GROUP: 'launch_white_board_in_group_allow',
    DENY_LAUNCH_WHITEBOARD_IN_GROUP: 'deny_white_board_in_group_allow',
    LAUNCH_WHITE_BOARD_TRAINER: "launch_white_board_trainer",
    DISABLE_SHARED_WHITEBOARD_TRAINER: 'share_disabled_white_board_trainer',
    SHARE_TRAINEE_DETAILS: 'share_trainee_detail',
    TIME_EXTEND:'time_extend',
    SYSTEM_REQUEST_DECLINED:'system_request_declined'
})

export const rolePlaySubType = {
    PRE_RECORDED_ROLE_PLAY_STARTED: 'pre_recorded_role_play_started',
    PRE_RECORDED_ROLE_PLAY_ENDED: 'pre_recorded_role_play_ended',
    VOLUNTEER_FOR_ROLEPLAY: "volunteer_for_roleplay",
    ROLEPLAY_LAUNCHED: "roleplay_launched",
    SYSTEM_SELECTED_FOR_ROLEPLAY: "system_selected_for_roleplay",
    VOLUNTEERS_SELECTED_EMAILS: "volunteers_selected_emails",
    ROLEPLAY_BRIEFING_STARTED: "roleplay_briefing_started",
    COMMON_BRIEFING_STARTED: "common_briefing_started",
    ROLE_PLAYER_SWAPPING: "role_player_swapping",
    TRAINER_SELECTED_FOR_ROLEPLAY: "trainer_selected_for_roleplay",
    UNMUTE_PARTICIPANT: "unmute_participant",
    OPEN_PRIVATE_ROOM: "open_private_room",
    VOLUNTEERS_REQUEST_ACCEPTED: 'volunteers_request_accepted',
    END_ROLEPLAY_ANALYSIS: 'end_roleplay_analysis',
    END_PRESENTATION: 'end_presentation',
    // for debrief flow
    SPLIT_ROOM: "split_room",
    LAUNCH_CASE_STUDY: "launch_group_discussion",
    VOLUNTEER_FOR_ROLEPLAY_DEBRIEF: "volunteer_for_roleplay_debrief",
    ALLOW_GROUPS_TO_VOLUNTEER: "allow_groups_to_volunteer",
    SYSTEM_REQUEST_ACCEPTED: "system_request_accepted",
    SELECTED_GROUP_ORDER: "selected_group_order",
    INITIATE_SELECTED_GROUP_ORDER: "initiate_selected_group_order",
    OPEN_CLASS_INTERACTION: "open_class_interaction",
    LAUNCH_PRESENTATION_SCREEN: "launch_presentation_screen",
    ASK_GROUP_TO_PRESENT: "ask_group_to_present",
    DRAG_SELECTED_GROUP_ORDER: 'drag_selected_group_order',
    ASK_GROUP_TO_PRESENT_PRESENATION: 'ask_group_to_present_presenation',
    ROLEPLAY_SETUP: 'roleplay_setup',
    LEADER_TRAINER_SELECT: 'leader_trainer_select',
    SELECT_GROUP_LEADER_EACH_GM: 'select_group_leader_each_GM',
    HANDLE_TRAINER_RESPONSE_ONEXTEND: 'handle_trainer_response_OnExtend',
    TIME_ABOUT_TO_OVER: 'time_about_to_over',// 2 minutes remaining,
    CONFIRM_EACH_GROUP_PICKS_GL: 'confirm_each_leader_select', // when each groups picks GL and GL determination is done based on nomination.
}

export const socketSteps ={
  PRESENTATION  :"Presentation"
}

export const rolePlayModalType = {
    YOU_VOLUNTEER: 'YOU_VOLUNTEER',
    SYSTEM_SELECT: 'SYSTEM_SELECT',
    USER_NOT_RESPOND: 'USER_NOT_RESPOND',
    YOU_SELECTED: 'YOU_SELECTED',
    OTHER_SELECTED: 'OTHER_SELECTED',
    YOU_NOMINATED: 'YOU_NOMINATED',
    ROLEPLAY_ANALYSIS: 'ROLEPLAY_ANALYSIS',
    DECLINED:'DECLINED',
    // debrief
    FIRST: "FIRST",
    SETUP: "setup",
    STANDBY: "standby",
    READYTOPRESENT: "readyToPresent",
    STARTPRESENTATION: "startPresentation",
    NOMINATEPRESENTER: "nominatePresenter",
    COMPLETEPREPARATION: "completePreparation",
    ORDERPREPARATION: "orderPreparation",
    HITBUTTON: 'hitButton',
    GROUPORDER: 'groupOrder',
    COMMENCE: 'commence',

    READY_TO_PRESENT_ALL: 'readyToPresentAll',
    READY_TO_PRESENT_GROUP_LEADER: 'readyToPresentGroupLeader',
    WAIT: 'wait',
    ENDWAIT: 'endWait',
    // 
    YOUSELECTEDGL: 'youSelectedGL',
    NOMINATEGL: "nominateGl",
    RANDOMLYSELECTED: "RANDOMLYSELECTED",
    YOUNEXT: 'youNext',
    WRAP_IN_TWO: 'WRAP_IN_TWO',
    TRAINER_HAS_EXTENDED_TIME: 'TRAINER_HAS_EXTENDED_TIME',
}

export const sessionModeType = {
    NETWORKING_MODE: "Break/Networking Mode",
    INSTRUCTOR_MODE: "Instructor Mode",
    ACTIVITY_MODE: "Activity Mode",
}

export const emojiType = {
    CLAP: "clap",
    THUMBS_UP: "thumbs_up",
    HIGH_FIVE: "high_five",
    HEART: "heart",
    HUNDRED: "100",
    SMILEY: "smiley",
}

export const csModalType = {
    FIRST: "FIRST",
    SETUP: "setup",
    STANDBY: "standby",
    READYTOPRESENT: "readyToPresent",
    STARTPRESENTATION: "startPresentation",
    NOMINATEPRESENTER: "nominatePresenter",
    COMPLETEPREPARATION: "completePreparation",
    ORDERPREPARATION: "orderPreparation",
    HITBUTTON: 'hitButton',
    GROUPORDER: 'groupOrder',
    COMMENCE: 'commence',

    READY_TO_PRESENT_ALL: 'readyToPresentAll',
    READY_TO_PRESENT_GROUP_LEADER: 'readyToPresentGroupLeader',
    WAIT: 'wait',
    ENDWAIT: 'endWait',

    // 
    YOUSELECTEDGL: 'youSelectedGL',
    NOMINATEGL: "nominateGl",
    RANDOMLYSELECTED: 'randomly_ selected',
    VIDEOCHATREQ: "videochatrequest",
    YOUNEXT: 'youNext'
}

export const csMode = {
    INIT: "init",
    PRESENTING: "presenting"
}

// custom activity
export const caModalType = {
    SETUP: "setup",
}

export const caMode = {
    INIT: "init",
}

export const csSubtype = {
    SPLIT_ROOM: "split_room",
    LAUNCH_CASE_STUDY: "launch_case_study",
    VOLUNTEER_FOR_CASE_STUDY: "volunteer_for_case_study",
    SYSTEM_REQUEST_ACCEPTED: "system_request_accepted",
    SELECTED_GROUP_ORDER: "selected_group_order",
    INITIATE_SELECTED_GROUP_ORDER: "initiate_selected_group_order",
    OPEN_CLASS_INTERACTION: "open_class_interaction",
    LAUNCH_PRESENTATION_SCREEN: "launch_presentation_screen",
    ASK_GROUP_TO_PRESENT: "ask_group_to_present",
    DRAG_SELECTED_GROUP_ORDER: 'drag_selected_group_order',
    ASK_GROUP_TO_PRESENT_PRESENATION: 'ask_group_to_present_presenation',
    CASE_STUDY_SETUP: 'case_study_setup',
    LEADER_TRAINER_SELECT: 'leader_trainer_select',
    SELECT_GROUP_LEADER_EACH_GM: 'select_group_leader_each_GM',
    ASK_FOR_VIDEO_CHAT: "ask_for_video_chat",
    PVT_VID_REQUEST_RESPONSE: "pvt_vid_request_response",
    END_PRESENTATION: "end_presentation",
    HANDLE_TRAINER_RESPONSE_ONEXTEND: 'handle_trainer_response_OnExtend',
    SELF_NOMINATION: 'self_nomination',
    CONFIRM_EACH_GROUP_PICKS_GL: 'confirm_each_leader_select', // when each groups picks GL and GL determination is done based on nomination.
}

export const gdSubtype = {
    SPLIT_ROOM: "split_room",
    LAUNCH_CASE_STUDY: "launch_group_discussion",
    VOLUNTEER_FOR_CASE_STUDY: "volunteer_for_case_study",
    SYSTEM_REQUEST_ACCEPTED: "system_request_accepted",
    SELECTED_GROUP_ORDER: "selected_group_order",
    INITIATE_SELECTED_GROUP_ORDER: "initiate_selected_group_order",
    OPEN_CLASS_INTERACTION: "open_class_interaction",
    LAUNCH_PRESENTATION_SCREEN: "launch_presentation_screen",
    ASK_GROUP_TO_PRESENT: "ask_group_to_present",
    DRAG_SELECTED_GROUP_ORDER: 'drag_selected_group_order',
    ASK_GROUP_TO_PRESENT_PRESENATION: 'ask_group_to_present_presenation',
    CASE_STUDY_SETUP: 'case_study_setup',
    LEADER_TRAINER_SELECT: 'leader_trainer_select',
    SELECT_GROUP_LEADER_EACH_GM: 'select_group_leader_each_GM',
    ALLOW_GROUPS_TO_VOLUNTEER: "allow_groups_to_volunteer",
    TIME_ABOUT_TO_OVER: 'time_about_to_over',// 2 minutes remaining,
    CONFIRM_EACH_GROUP_PICKS_GL: 'confirm_each_leader_select', // when each groups picks GL and GL determination is done based on nomination.
    VOLUNTEERS_SELECTED_EMAILS: "volunteers_selected_emails",
    END_PRESENTATION: 'end_presentation',
    GROUP_DISCUSSION_ENDED: 'group_discussion_ended',
    HANDLE_TRAINER_RESPONSE_ONEXTEND: 'handle_trainer_response_OnExtend',
}

export const pollSubtype = {
    DOT_SHOW_QUESTION_SCREEN_SCORE: 'dot_show_question_screen_score',
    CLOSE_VOTING_BROADCAST: 'close_voting_broadcast',
    SHOW_INITIAL_SCREEN: 'show_initial_screen',
    SHOW_QUESTION_SCREENS: 'show_question_screens',
    SHOW_QUESTION_SCREEN_SCORE: 'show_question_screen_score',
    GET_TRAINEE_RESPONSES:'get_trainee_responses'
}

export const pollActivityModalType = {
    VOTING_CLOSED: 'voting_closed',
    POLL_LAUNCHED: 'poll_launched',
    WAITING_OTHERS: 'waiting_others',
    SHOW_QUESTION_SCREENS: 'show_question_screens',
    SHOW_RESPONSE: 'show_response',
}

export const gdModalType = {
    // SETUP: "setup",
    // LAUNCH: 'launch',
    // END: 'end',
    // ENDWAIT: 'endwait',
    // // 
    // READYTOPRESENT: "readyToPresent",
    // STARTPRESENTATION: "startPresentation",
    // NOMINATEPRESENTER: "nominatePresenter",
    // COMPLETEPREPARATION: "completePreparation",
    // ORDERPREPARATION: "orderPreparation",
    // HITBUTTON: 'hitButton',
    // GROUPORDER: 'groupOrder',
    // COMMENCE: 'commence',

    // READY_TO_PRESENT_ALL: 'readyToPresentAll',
    // READY_TO_PRESENT_GROUP_LEADER: 'readyToPresentGroupLeader',
    // WAIT: 'wait'
    FIRST: "FIRST",
    SETUP: "setup",
    STANDBY: "standby",
    READYTOPRESENT: "readyToPresent",
    STARTPRESENTATION: "startPresentation",
    NOMINATEPRESENTER: "nominatePresenter",
    COMPLETEPREPARATION: "completePreparation",
    ORDERPREPARATION: "orderPreparation",
    HITBUTTON: 'hitButton',
    GROUPORDER: 'groupOrder',
    COMMENCE: 'commence',

    READY_TO_PRESENT_ALL: 'readyToPresentAll',
    READY_TO_PRESENT_GROUP_LEADER: 'readyToPresentGroupLeader',
    WAIT: 'wait',
    ENDWAIT: 'endWait',
    // 
    YOUSELECTEDGL: 'youSelectedGL',
    NOMINATEGL: "nominateGl",
    RANDOMLYSELECTED: 'randomly_ selected',
    YOUR_GRP_NEXT: 'your_group_next',
    YOUNEXT: 'youNext',
    WRAP_IN_TWO: 'WRAP_IN_TWO',
    OTHER_SELECTED: 'OTHER_SELECTED',
    YOU_SELECTED: 'YOU_SELECTED',
    DISCUSSION_ENDED: 'DISCUSSION_ENDED',
    TRAINER_HAS_EXTENDED_TIME: 'TRAINER_HAS_EXTENDED_TIME',
}

export enum joinType {
    JOINED = 'joined',
    LEFT = 'left',
}

export enum roles {
    GUEST = 'guest',
    TRAINER = 'trainer',
    TRAINEE = 'trainee'
}

export enum chatParticipantType {
    TRAINER = 'Trainer',
    PARTICIPANT = 'Participant'
}

export const closeEntryAfterSessionStartTime = 10 // in miniute 